import { render, staticRenderFns } from "./UnresolvedCommentsRowButton.vue?vue&type=template&id=7d3fe000&scoped=true"
import script from "./UnresolvedCommentsRowButton.vue?vue&type=script&lang=js"
export * from "./UnresolvedCommentsRowButton.vue?vue&type=script&lang=js"
import style0 from "./UnresolvedCommentsRowButton.vue?vue&type=style&index=0&id=7d3fe000&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3fe000",
  null
  
)

export default component.exports